/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisplayBrightnessResponse } from './DisplayBrightnessResponse';
import {
    DisplayBrightnessResponseFromJSON,
    DisplayBrightnessResponseFromJSONTyped,
    DisplayBrightnessResponseToJSON,
    DisplayBrightnessResponseToJSONTyped,
} from './DisplayBrightnessResponse';
import type { PreheatSetpointResponse } from './PreheatSetpointResponse';
import {
    PreheatSetpointResponseFromJSON,
    PreheatSetpointResponseFromJSONTyped,
    PreheatSetpointResponseToJSON,
    PreheatSetpointResponseToJSONTyped,
} from './PreheatSetpointResponse';
import type { SharingPolicyResponse } from './SharingPolicyResponse';
import {
    SharingPolicyResponseFromJSON,
    SharingPolicyResponseFromJSONTyped,
    SharingPolicyResponseToJSON,
    SharingPolicyResponseToJSONTyped,
} from './SharingPolicyResponse';
import type { ErrorsResponse } from './ErrorsResponse';
import {
    ErrorsResponseFromJSON,
    ErrorsResponseFromJSONTyped,
    ErrorsResponseToJSON,
    ErrorsResponseToJSONTyped,
} from './ErrorsResponse';
import type { RemoteLoggingResponse } from './RemoteLoggingResponse';
import {
    RemoteLoggingResponseFromJSON,
    RemoteLoggingResponseFromJSONTyped,
    RemoteLoggingResponseToJSON,
    RemoteLoggingResponseToJSONTyped,
} from './RemoteLoggingResponse';
import type { WeekscheduleResponse } from './WeekscheduleResponse';
import {
    WeekscheduleResponseFromJSON,
    WeekscheduleResponseFromJSONTyped,
    WeekscheduleResponseToJSON,
    WeekscheduleResponseToJSONTyped,
} from './WeekscheduleResponse';
import type { DeviceInfoResponse } from './DeviceInfoResponse';
import {
    DeviceInfoResponseFromJSON,
    DeviceInfoResponseFromJSONTyped,
    DeviceInfoResponseToJSON,
    DeviceInfoResponseToJSONTyped,
} from './DeviceInfoResponse';
import type { FlameStateResponse } from './FlameStateResponse';
import {
    FlameStateResponseFromJSON,
    FlameStateResponseFromJSONTyped,
    FlameStateResponseToJSON,
    FlameStateResponseToJSONTyped,
} from './FlameStateResponse';
import type { FilterStateResponse } from './FilterStateResponse';
import {
    FilterStateResponseFromJSON,
    FilterStateResponseFromJSONTyped,
    FilterStateResponseToJSON,
    FilterStateResponseToJSONTyped,
} from './FilterStateResponse';
import type { HeatPumpSetupResponse } from './HeatPumpSetupResponse';
import {
    HeatPumpSetupResponseFromJSON,
    HeatPumpSetupResponseFromJSONTyped,
    HeatPumpSetupResponseToJSON,
    HeatPumpSetupResponseToJSONTyped,
} from './HeatPumpSetupResponse';
import type { WeekscheduleStateResponse } from './WeekscheduleStateResponse';
import {
    WeekscheduleStateResponseFromJSON,
    WeekscheduleStateResponseFromJSONTyped,
    WeekscheduleStateResponseToJSON,
    WeekscheduleStateResponseToJSONTyped,
} from './WeekscheduleStateResponse';
import type { VentilationResponse } from './VentilationResponse';
import {
    VentilationResponseFromJSON,
    VentilationResponseFromJSONTyped,
    VentilationResponseToJSON,
    VentilationResponseToJSONTyped,
} from './VentilationResponse';
import type { AmbientOffsetResponse } from './AmbientOffsetResponse';
import {
    AmbientOffsetResponseFromJSON,
    AmbientOffsetResponseFromJSONTyped,
    AmbientOffsetResponseToJSON,
    AmbientOffsetResponseToJSONTyped,
} from './AmbientOffsetResponse';
import type { ClimateModeResponse } from './ClimateModeResponse';
import {
    ClimateModeResponseFromJSON,
    ClimateModeResponseFromJSONTyped,
    ClimateModeResponseToJSON,
    ClimateModeResponseToJSONTyped,
} from './ClimateModeResponse';
import type { LegionellaResponse } from './LegionellaResponse';
import {
    LegionellaResponseFromJSON,
    LegionellaResponseFromJSONTyped,
    LegionellaResponseToJSON,
    LegionellaResponseToJSONTyped,
} from './LegionellaResponse';
import type { DiagnosticsEmbed } from './DiagnosticsEmbed';
import {
    DiagnosticsEmbedFromJSON,
    DiagnosticsEmbedFromJSONTyped,
    DiagnosticsEmbedToJSON,
    DiagnosticsEmbedToJSONTyped,
} from './DiagnosticsEmbed';
import type { SettingsResponse } from './SettingsResponse';
import {
    SettingsResponseFromJSON,
    SettingsResponseFromJSONTyped,
    SettingsResponseToJSON,
    SettingsResponseToJSONTyped,
} from './SettingsResponse';
import type { DhwBoostResponse } from './DhwBoostResponse';
import {
    DhwBoostResponseFromJSON,
    DhwBoostResponseFromJSONTyped,
    DhwBoostResponseToJSON,
    DhwBoostResponseToJSONTyped,
} from './DhwBoostResponse';
import type { DhwPreferencesResponse } from './DhwPreferencesResponse';
import {
    DhwPreferencesResponseFromJSON,
    DhwPreferencesResponseFromJSONTyped,
    DhwPreferencesResponseToJSON,
    DhwPreferencesResponseToJSONTyped,
} from './DhwPreferencesResponse';
import type { BoilerControlModeResponse } from './BoilerControlModeResponse';
import {
    BoilerControlModeResponseFromJSON,
    BoilerControlModeResponseFromJSONTyped,
    BoilerControlModeResponseToJSON,
    BoilerControlModeResponseToJSONTyped,
} from './BoilerControlModeResponse';
import type { RoomSetpointResponse } from './RoomSetpointResponse';
import {
    RoomSetpointResponseFromJSON,
    RoomSetpointResponseFromJSONTyped,
    RoomSetpointResponseToJSON,
    RoomSetpointResponseToJSONTyped,
} from './RoomSetpointResponse';

/**
 * 
 * @export
 * @interface ConfigResponse
 */
export interface ConfigResponse {
    /**
     * 
     * @type {DiagnosticsEmbed}
     * @memberof ConfigResponse
     */
    diagnostics?: DiagnosticsEmbed;
    /**
     * 
     * @type {AmbientOffsetResponse}
     * @memberof ConfigResponse
     */
    ambientOffset?: AmbientOffsetResponse;
    /**
     * 
     * @type {BoilerControlModeResponse}
     * @memberof ConfigResponse
     */
    boilerControlMode?: BoilerControlModeResponse;
    /**
     * 
     * @type {ClimateModeResponse}
     * @memberof ConfigResponse
     */
    climateMode?: ClimateModeResponse;
    /**
     * 
     * @type {DeviceInfoResponse}
     * @memberof ConfigResponse
     */
    deviceInfo?: DeviceInfoResponse;
    /**
     * 
     * @type {DhwBoostResponse}
     * @memberof ConfigResponse
     */
    dhwBoost?: DhwBoostResponse;
    /**
     * 
     * @type {DhwPreferencesResponse}
     * @memberof ConfigResponse
     */
    dhwPreferences?: DhwPreferencesResponse;
    /**
     * 
     * @type {DisplayBrightnessResponse}
     * @memberof ConfigResponse
     */
    displayBrightness?: DisplayBrightnessResponse;
    /**
     * 
     * @type {ErrorsResponse}
     * @memberof ConfigResponse
     */
    errors?: ErrorsResponse;
    /**
     * 
     * @type {FilterStateResponse}
     * @memberof ConfigResponse
     */
    filterState?: FilterStateResponse;
    /**
     * 
     * @type {FlameStateResponse}
     * @memberof ConfigResponse
     */
    flameState?: FlameStateResponse;
    /**
     * 
     * @type {HeatPumpSetupResponse}
     * @memberof ConfigResponse
     */
    heatPumpSetup?: HeatPumpSetupResponse;
    /**
     * 
     * @type {LegionellaResponse}
     * @memberof ConfigResponse
     */
    legionella?: LegionellaResponse;
    /**
     * 
     * @type {PreheatSetpointResponse}
     * @memberof ConfigResponse
     */
    preheatSetpoint?: PreheatSetpointResponse;
    /**
     * 
     * @type {RemoteLoggingResponse}
     * @memberof ConfigResponse
     */
    remoteLogging?: RemoteLoggingResponse;
    /**
     * 
     * @type {RoomSetpointResponse}
     * @memberof ConfigResponse
     */
    roomSetpoint?: RoomSetpointResponse;
    /**
     * 
     * @type {SettingsResponse}
     * @memberof ConfigResponse
     */
    settings?: SettingsResponse;
    /**
     * 
     * @type {SharingPolicyResponse}
     * @memberof ConfigResponse
     */
    sharingPolicy?: SharingPolicyResponse;
    /**
     * 
     * @type {VentilationResponse}
     * @memberof ConfigResponse
     */
    ventilation?: VentilationResponse;
    /**
     * 
     * @type {WeekscheduleResponse}
     * @memberof ConfigResponse
     */
    weekschedule?: WeekscheduleResponse;
    /**
     * 
     * @type {WeekscheduleStateResponse}
     * @memberof ConfigResponse
     */
    weekscheduleState?: WeekscheduleStateResponse;
}

/**
 * Check if a given object implements the ConfigResponse interface.
 */
export function instanceOfConfigResponse(value: object): value is ConfigResponse {
    return true;
}

export function ConfigResponseFromJSON(json: any): ConfigResponse {
    return ConfigResponseFromJSONTyped(json, false);
}

export function ConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnostics': json['diagnostics'] == null ? undefined : DiagnosticsEmbedFromJSON(json['diagnostics']),
        'ambientOffset': json['ambient_offset'] == null ? undefined : AmbientOffsetResponseFromJSON(json['ambient_offset']),
        'boilerControlMode': json['boiler_control_mode'] == null ? undefined : BoilerControlModeResponseFromJSON(json['boiler_control_mode']),
        'climateMode': json['climate_mode'] == null ? undefined : ClimateModeResponseFromJSON(json['climate_mode']),
        'deviceInfo': json['device_info'] == null ? undefined : DeviceInfoResponseFromJSON(json['device_info']),
        'dhwBoost': json['dhw_boost'] == null ? undefined : DhwBoostResponseFromJSON(json['dhw_boost']),
        'dhwPreferences': json['dhw_preferences'] == null ? undefined : DhwPreferencesResponseFromJSON(json['dhw_preferences']),
        'displayBrightness': json['display_brightness'] == null ? undefined : DisplayBrightnessResponseFromJSON(json['display_brightness']),
        'errors': json['errors'] == null ? undefined : ErrorsResponseFromJSON(json['errors']),
        'filterState': json['filter_state'] == null ? undefined : FilterStateResponseFromJSON(json['filter_state']),
        'flameState': json['flame_state'] == null ? undefined : FlameStateResponseFromJSON(json['flame_state']),
        'heatPumpSetup': json['heat_pump_setup'] == null ? undefined : HeatPumpSetupResponseFromJSON(json['heat_pump_setup']),
        'legionella': json['legionella'] == null ? undefined : LegionellaResponseFromJSON(json['legionella']),
        'preheatSetpoint': json['preheat_setpoint'] == null ? undefined : PreheatSetpointResponseFromJSON(json['preheat_setpoint']),
        'remoteLogging': json['remote_logging'] == null ? undefined : RemoteLoggingResponseFromJSON(json['remote_logging']),
        'roomSetpoint': json['room_setpoint'] == null ? undefined : RoomSetpointResponseFromJSON(json['room_setpoint']),
        'settings': json['settings'] == null ? undefined : SettingsResponseFromJSON(json['settings']),
        'sharingPolicy': json['sharing_policy'] == null ? undefined : SharingPolicyResponseFromJSON(json['sharing_policy']),
        'ventilation': json['ventilation'] == null ? undefined : VentilationResponseFromJSON(json['ventilation']),
        'weekschedule': json['weekschedule'] == null ? undefined : WeekscheduleResponseFromJSON(json['weekschedule']),
        'weekscheduleState': json['weekschedule_state'] == null ? undefined : WeekscheduleStateResponseFromJSON(json['weekschedule_state']),
    };
}

export function ConfigResponseToJSON(json: any): ConfigResponse {
    return ConfigResponseToJSONTyped(json, false);
}

export function ConfigResponseToJSONTyped(value?: ConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnostics': DiagnosticsEmbedToJSON(value['diagnostics']),
        'ambient_offset': AmbientOffsetResponseToJSON(value['ambientOffset']),
        'boiler_control_mode': BoilerControlModeResponseToJSON(value['boilerControlMode']),
        'climate_mode': ClimateModeResponseToJSON(value['climateMode']),
        'device_info': DeviceInfoResponseToJSON(value['deviceInfo']),
        'dhw_boost': DhwBoostResponseToJSON(value['dhwBoost']),
        'dhw_preferences': DhwPreferencesResponseToJSON(value['dhwPreferences']),
        'display_brightness': DisplayBrightnessResponseToJSON(value['displayBrightness']),
        'errors': ErrorsResponseToJSON(value['errors']),
        'filter_state': FilterStateResponseToJSON(value['filterState']),
        'flame_state': FlameStateResponseToJSON(value['flameState']),
        'heat_pump_setup': HeatPumpSetupResponseToJSON(value['heatPumpSetup']),
        'legionella': LegionellaResponseToJSON(value['legionella']),
        'preheat_setpoint': PreheatSetpointResponseToJSON(value['preheatSetpoint']),
        'remote_logging': RemoteLoggingResponseToJSON(value['remoteLogging']),
        'room_setpoint': RoomSetpointResponseToJSON(value['roomSetpoint']),
        'settings': SettingsResponseToJSON(value['settings']),
        'sharing_policy': SharingPolicyResponseToJSON(value['sharingPolicy']),
        'ventilation': VentilationResponseToJSON(value['ventilation']),
        'weekschedule': WeekscheduleResponseToJSON(value['weekschedule']),
        'weekschedule_state': WeekscheduleStateResponseToJSON(value['weekscheduleState']),
    };
}

